import {
	type OrderSetupDetailResponseDto,
	OrderSetupStatusEnum,
} from "Infrastructure/Api/Api";
import { useCreateOrderSetupMutation } from "Settings/Modules/OrderSetup/Api/Mutation/useCreateOrderSetupMutation";
import { ContentCopy } from "@mui/icons-material";
import { Button } from "@mui/material";
import type { FC } from "react";

type Props = {
	orderSetup: OrderSetupDetailResponseDto;
	marketId: number;
	verticalId: number;
};

export const OrderSetupCopyButton: FC<Props> = ({
	orderSetup,
	marketId,
	verticalId,
}) => {
	const { mutate: createOrderSetup, isPending: isPendingCreate } =
		useCreateOrderSetupMutation();

	const handleCopyOrderSetup = () => {
		const updatedOrderFields = orderSetup.orderFields.map(
			({ id, emailLabel, isEmailIncluded, ...rest }) => ({
				...rest,
				emailLabel: emailLabel ?? "",
				isEmailIncluded: isEmailIncluded ?? true,
			}),
		);

		createOrderSetup({
			marketId,
			verticalId,
			orderFields: updatedOrderFields,
			status: OrderSetupStatusEnum.draft,
		});
	};

	return (
		<Button
			size="small"
			onClick={handleCopyOrderSetup}
			startIcon={<ContentCopy />}
			loading={isPendingCreate}
		>
			Copy setup
		</Button>
	);
};
